import axios, { extractData } from '@atheneum/api'
import { extendObservable } from 'mobx'

class ContactProjectsStore {
  constructor (staticData) {
    extendObservable(this, {
      page: 1,
      clientId: null,
      staticData,
      loading: false,
      error: null,
      total: null,
      projects: []
    })
  }

  loadClientProjects = id => {
    this.loading = true
    this.clientId = id
    return axios
      .get(`/api/client/projects/${id}?limit=10&page=${this.page}`)
      .then(res => {
        const responseData = extractData(res)
        this.total = responseData.total
        const formattedData = responseData.rows.map(row => {
          const statusId = row.projectStatusId
          const status = this.staticData.names.projectStatuses[statusId]
          return { ...row, projectStatus: status }
        })
        this.projects.replace(formattedData)
      })
      .then(() => {
        this.loading = false
      })
      .catch(err => {
        this.error = err
      })
  }

  changePage (page) {
    this.page = page
    this.loadClientProjects(this.clientId)
  }
}

export default ContactProjectsStore
